<template>
    
    <Card class="w-full">
        <template #title>
            <div class="text-center">
                Ops!
            </div>
        </template>
        <template #content>
            <Message class="flex justify-content-center p-4 my-4" severity="error">
                Página não encontrada!     
            </Message>
            <div class="text-center">
                <Button label="Voltar" icon="pi pi-angle-left" @click="goBack" />
            </div>
        </template>
    </Card>
</template>

<script>
import Card from 'primevue/card';
import Message from 'primevue/message';
import Button from 'primevue/button';

export default {
    components: {
        Card,
        Message,
        Button
    },
    methods: {
        goBack() {
            history.back(); 
            return false;
        }
    }
};
</script>